module.exports = __webpack_public_path__ + "img/KH.4125dbd2.png";